<template>
  <b-container id="request-details">
    <b-spinner v-show="!isLoaded" label="Loading..." />
    <b-card
      v-show="isLoaded"
      :header-text-variant="foregroundColorVariant"
      :header-bg-variant="backgroundColorVariant"
      :header="request.citName + ' - ' + request.disName"
    >
      <b-card-body class="text-left">
        <p><b>Anfrage von:</b> {{ request.reqRequesterName }}</p>
        <p><b>Erwarteter Geburtstermin:</b> {{ request.reqChildbirthDate }}</p>
        <p><b>Telefon:</b> {{ request.reqPhoneNumber }}</p>
        <p><b>E-Mail:</b> {{ request.reqEmail }}</p>
        <p v-if="request.wishUserFirstName">
          <b>Wunsch-Hebamme:</b>
          {{ request.wishUserFirstName + " " + request.wishUserLastName }}
        </p>
        <p class="low-margin-text"><b>Gewünschte Dienstleistungen:</b></p>
        <b-list-group class="standard-margin-bottom">
          <b-list-group-item
            v-for="service in request.services"
            :key="service.serId"
            class="text-left"
          >
            {{ $t(service.serTranslationId, "de") }}
          </b-list-group-item>
        </b-list-group>

        <div v-if="(request.assignedDeliveryNurses || []).length > 0">
          <p class="low-margin-text"><b>Zugewiesene Hebammen:</b></p>
          <b-list-group class="big-margin-bottom">
            <b-list-group-item
              class="flex-column justify-content-between align-items-center"
              v-for="nurse in request.assignedDeliveryNurses"
              :key="nurse.usrId"
            >
              <div
                class="d-flex w-100 justify-content-between align-items-center"
              >
                <span>{{ nurse.usrFirstName }} {{ nurse.usrLastName }}</span>
                <!--                <div v-if="isUserRole(roles.ADMINISTRATOR)">-->
                <div>
                  <b-button
                    variant="primary"
                    @click="assignNurse(nurse.usrId, assignmentModes.FULLY)"
                    v-if="
                      isUserRole(roles.ADMINISTRATOR) &&
                        request.statusId ===
                          statuses.PARTIALLY_ASSIGNED.toString()
                    "
                  >
                    Voll zuweisen
                  </b-button>
                  <b-button
                    variant="primary"
                    @click="assignNurse(nurse.usrId, assignmentModes.PARTIALLY)"
                    v-if="
                      isUserRole(roles.ADMINISTRATOR) &&
                        request.statusId === statuses.MEDIATED.toString() &&
                        request.assignedDeliveryNurses.length === 1
                    "
                  >
                    Teilweise zuweisen
                  </b-button>
                  <b-button
                    class="ml-2"
                    variant="success"
                    @click="assignNurse(nurse.usrId, assignmentModes.REMOVE)"
                    v-if="
                      isUserRole(roles.ADMINISTRATOR) &&
                        (request.statusId ===
                          statuses.PARTIALLY_ASSIGNED.toString() ||
                          request.statusId === statuses.MEDIATED.toString())
                    "
                  >
                    Aufheben
                  </b-button>
                </div>
              </div>
              <small v-if="nurse.rxuComment"
                ><b>Kommentar:</b> {{ nurse.rxuComment }}</small
              >
            </b-list-group-item>
          </b-list-group>
        </div>

        <div v-if="showAddCommentOption">
          <p>
            <b>Kommentar:</b>
          </p>
          <b-form-textarea v-model="comment" max-rows="3"> </b-form-textarea>
        </div>
        <div v-if="request.statusId !== statuses.MEDIATED.toString()">
          <p class="low-margin-text">
            <b>Hebamme zuweisen:</b>
            <b-spinner small v-if="isAssigning" class="text-center ml-3" />
          </p>
          <request-actions-nurse
            :disabled="isAssigning"
            :noPart="
              request.assignedDeliveryNurses &&
                request.assignedDeliveryNurses.length > 0 &&
                request.assignedDeliveryNurses[0].usrId === usrId
            "
            :noFull="
              request.assignedDeliveryNurses &&
                request.assignedDeliveryNurses.length > 0 &&
                request.assignedDeliveryNurses[0].usrId !== usrId
            "
            @assign="assignSelectedNurse($event)"
            v-if="isUserRole(roles.DELIVERY_NURSE)"
          />
          <request-actions-admin
            :disabled="isAssigning"
            :noFull="
              request.assignedDeliveryNurses &&
                request.assignedDeliveryNurses.length > 0
            "
            :availableNurses="availableNurses"
            @assign="assignSelectedNurse($event)"
            v-model="selectedNurseId"
            v-if="isUserRole(roles.ADMINISTRATOR)"
          />
        </div>
      </b-card-body>
    </b-card>
  </b-container>
</template>

<script>
import { statusColorMixin } from "../mixins/statusColors";
import { authMixin } from "../mixins/auth";
import RequestActionsNurse from "../components/RequestActionsNurse";
import RequestActionsAdmin from "../components/RequestActionsAdmin";
import { assignmentModeEnum, statusEnum } from "../utils/enums";

export default {
  name: "RequestDetails",
  mixins: [statusColorMixin, authMixin],
  components: {
    RequestActionsNurse,
    RequestActionsAdmin
  },
  data() {
    return {
      statuses: statusEnum,
      request: 0,
      availableNurses: [],
      selectedNurseId: null,
      isLoaded: false,
      isAssigning: false,
      assignmentModes: assignmentModeEnum,
      comment: "",
      usrId: 0
    };
  },
  created() {
    this.usrId = localStorage.getItem("usrId");
    this.$http
      .get("/request/item/" + this.$route.params.id)
      .then(this.updateDetails)
      .finally(() => (this.isLoaded = true));
  },
  methods: {
    updateDetails(response) {
      this.request = response.data.data.request;
      if (this.isUserRole(this.roles.ADMINISTRATOR)) {
        this.availableNurses = this.filterNotAssignedNurses(response);
      }
    },
    filterNotAssignedNurses(response) {
      let assignedNursesIds = this.request.assignedDeliveryNurses.map(
        nurse => nurse.usrId
      );
      return response.data.data.availableDeliveryNurses.filter(
        nurse => !assignedNursesIds.includes(nurse.usrId)
      );
    },
    assignSelectedNurse(mode) {
      // alert(this.selectedNurseId);
      this.assignNurse(this.selectedNurseId, mode);
    },
    assignNurse(nurseId, mode) {
      // alert("Nurse " + nurseId + " Mode " + mode);
      const path = "/request/" + this.request.reqId + "/assign";
      let form = new FormData();
      form.append("assignmentMode", mode);
      if (this.isUserRole(this.roles.ADMINISTRATOR)) {
        form.append("userId", nurseId);
      }
      if (
        this.isUserRole(this.roles.DELIVERY_NURSE) &&
        (this.request.statusId === this.statuses.OPEN.toString() ||
          this.request.statusId ===
            this.statuses.PARTIALLY_ASSIGNED.toString()) &&
        mode === this.assignmentModes.PARTIALLY
      ) {
        form.append("comment", this.comment);
      }
      this.isAssigning = true;
      this.$http
        .post(path, form)
        .then(this.updateDetails)
        .finally(() => (this.isAssigning = false));
    }
  },
  computed: {
    showAddCommentOption() {
      return (
        this.isUserRole(this.roles.DELIVERY_NURSE) &&
        (this.request.statusId === this.statuses.OPEN.toString() ||
          this.request.statusId === this.statuses.PARTIALLY_ASSIGNED.toString())
      );
    }
  }
};
</script>

<style scoped>
.big-margin-bottom {
  margin-bottom: 30px;
}

.standard-margin-bottom {
  margin-bottom: 16px;
}

.low-margin-text {
  margin-bottom: 8px;
}
</style>
